import React from 'react';
import { SeatsWidget } from './SeatsWidget';
import { MetricsWidget } from './MetricsWidget';
import { ReportWidget } from './ReportWidget';
import { TeamWidgetData } from '../../services/teamSummary';

interface WidgetsProps {
  data?: TeamWidgetData;
  onTeamDataRefresh?: () => Promise<void> | void;
}

export const Widgets: React.FC<WidgetsProps> = ({ data, onTeamDataRefresh }) => {
  if (!data) {
    return null;
  }

  return (
    <section className="w-full py-2.5">
      <div className="flex flex-col sm:flex-row gap-2">
        <SeatsWidget
          usedSeats={data.seats.usedSeats}
          totalSeats={data.seats.totalSeats}
          onTeamDataRefresh={onTeamDataRefresh}
        />
        <MetricsWidget
          activeUsers={data.metrics.activeUsers}
          totalUsers={data.metrics.totalUsers}
          totalCoursesCompleted={data.metrics.totalCoursesCompleted}
        />
        <ReportWidget
          certifications={data.report.certifications}
        />
      </div>
    </section>
  );
};
